import { render } from "./ImageWithFallback.vue?vue&type=template&id=5037d724"
import script from "./ImageWithFallback.vue?vue&type=script&lang=js"
export * from "./ImageWithFallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__